import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`By default, PostHog only collects the `}<inlineCode parentName="p">{`name`}</inlineCode>{`, `}<inlineCode parentName="p">{`id`}</inlineCode>{`, and `}<inlineCode parentName="p">{`class`}</inlineCode>{` attributes from `}<inlineCode parentName="p">{`<input>`}</inlineCode>{` tags.`}</p>
    <p>{`If there are other HTML elements you don't want captured, you can add the `}<inlineCode parentName="p">{`ph-no-capture`}</inlineCode>{` class to the element.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js-web"
      }}>{`<button class='ph-no-capture'>Sensitive information here</button>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      